module.exports = "  <div>  \n    <p>{{\"SOLIDARITY.WHAT_IS_SOLIDARY_EURO.SUBTITLE\" | translate}}</p>\n  </div>\n<div class=\"solidarity-list\">\n  <div class=\"card-list\" ng-repeat=\"card in $ctrl.cards\">\n    <what-is-solidary-card card-data=\"card\"></what-is-solidary-card>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryList/whatIsSolidaryList.html
// module id = 2254
// module chunks = 0